import React from 'react';
import { Star, Clock, Check, AlertCircle, Truck, ShieldCheck, ArrowRight } from 'lucide-react';
export function App() {
  return <div className="min-h-screen bg-white" data-id="element-0">
      {/* Top Navigation Bar (Mock) */}
      <nav className="border-b border-gray-200 bg-white sticky top-0 z-50" data-id="element-1">
        <div className="max-w-5xl mx-auto px-4 h-16 flex items-center justify-between" data-id="element-2">
          <div className="font-serif text-2xl font-bold tracking-tight text-gray-900" data-id="element-3">
            Salud y Bienestar
          </div>
          <a href="https://angelitasgummy.com/products/angelitas" target="_blank" rel="noopener noreferrer" className="bg-[#d4738c] text-white px-4 py-2 rounded-full text-sm font-medium hover:bg-[#c05f77] transition-colors no-underline" data-id="element-4">
            Ver Oferta
          </a>
        </div>
      </nav>

      <main className="max-w-3xl mx-auto px-4 py-12" data-id="element-5">
        {/* Article Header */}
        <header className="mb-10 text-center md:text-left" data-id="element-6">
          <div className="flex items-center justify-center md:justify-start gap-2 mb-6" data-id="element-7">
            <span className="bg-gray-100 text-gray-600 px-3 py-1 rounded-full text-xs font-bold tracking-wider uppercase" data-id="element-8">
              Salud
            </span>
            <span className="text-gray-400 text-xs font-bold tracking-wider uppercase" data-id="element-9">
              |
            </span>
            <span className="text-[#d4738c] text-xs font-bold tracking-wider uppercase" data-id="element-10">
              SALUD MUJER
            </span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-6" data-id="element-11">
            Haz Esta Prueba de 10 Segundos En Tus Tobillos — Si Pasa ESTO, Tus
            Piernas Están En Peligro
          </h1>

          <p className="text-xl text-gray-600 leading-relaxed mb-8 font-serif italic" data-id="element-12">
            Un simple truco que los cardiólogos usan para detectar problemas de
            circulación que las mujeres mexicanas confunden con "cansancio
            normal."
          </p>

          <div className="flex items-center border-t border-b border-gray-100 py-4" data-id="element-13">
            <div className="flex-shrink-0 mr-4" data-id="element-14">
              <img src="https://cdn.magicpatterns.com/uploads/tYnXXLvzmusrKyA7dfhSKb/Captura_de_pantalla_2026-01-24_a_las_12.17.15.png" alt="Redacción Salud y Bienestar" className="h-12 w-12 rounded-full object-cover" data-id="element-15" />
            </div>
            <div className="text-sm" data-id="element-16">
              <p className="font-bold text-gray-900" data-id="element-17">
                Por Redacción Salud y Bienestar
              </p>
              <div className="flex items-center text-gray-500 gap-4 mt-1" data-id="element-18">
                <span data-id="element-19">Diciembre 2025</span>
                <span className="flex items-center" data-id="element-20">
                  <span className="w-1 h-1 bg-gray-400 rounded-full mr-2" data-id="element-21"></span>
                  186,492 lecturas
                </span>
              </div>
            </div>
          </div>
        </header>

        {/* Featured Image Placeholder */}
        <figure className="mb-12" data-id="element-22">
          <div className="aspect-video w-full bg-gray-100 rounded-xl overflow-hidden relative" data-id="element-23">
            <img src="https://cdn.magicpatterns.com/uploads/6d9vovCJCRpHc4iuyn9dcC/what-are-the-symptoms-of-chronic-venous-insufficiency-treatment.jpg" alt="Mujer revisando sus tobillos" className="w-full h-full object-cover" data-id="element-24" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent" data-id="element-25"></div>
          </div>
          <figcaption className="text-sm text-gray-500 mt-3 text-center italic" data-id="element-26">
            La hinchazón en los tobillos puede ser la primera señal de alerta.
          </figcaption>
        </figure>

        {/* Article Body */}
        <article className="prose prose-lg prose-gray max-w-none prose-p:mb-6" data-id="element-27">
          <p className="first-letter:text-5xl first-letter:font-serif first-letter:font-bold first-letter:text-gray-900 first-letter:mr-3 first-letter:float-left mb-6" data-id="element-28">
            Gloria Martínez tiene 54 años y vive en Guadalajara. Aquella noche
            de octubre, después de un día largo cuidando a su mamá y preparando
            la comida para toda la familia, se dejó caer en el sillón de su sala
            y se quitó los zapatos.
          </p>

          <p className="mb-6" data-id="element-29">Lo que vio la dejó helada.</p>

          <p className="mb-6" data-id="element-30">
            Sus pies estaban tan hinchados que apenas reconocía los dedos. Los
            tobillos habían desaparecido. Sus piernas, que alguna vez fueron
            delgadas, ahora parecían dos troncos pesados que no le pertenecían.
          </p>

          <blockquote className="border-l-4 border-[#d4738c] pl-6 py-2 my-8 bg-rose-50 rounded-r-lg" data-id="element-31">
            <p className="text-xl font-serif italic text-gray-800 m-0" data-id="element-32">
              "Parecían pies de otra persona," recuerda Gloria. "Llevaba meses
              viéndolos así, pero esa noche fue diferente. Me asusté."
            </p>
          </blockquote>

          <p className="mb-6" data-id="element-33">
            Su hija Fernanda, que es enfermera en un hospital privado, estaba de
            visita. Vio la cara de su mamá y le dijo algo que cambiaría todo:
          </p>

          <p className="font-bold text-gray-900 mb-6" data-id="element-34">
            "Mamá, haz esta prueba. La usamos en el hospital para detectar
            problemas de circulación."
          </p>

          {/* Interactive Test Section */}
          <div className="my-12 bg-gray-50 border border-gray-200 rounded-2xl p-8 shadow-sm relative overflow-hidden" data-id="element-35">
            <div className="absolute top-0 left-0 w-full h-2 bg-[#d4738c]" data-id="element-36"></div>
            <div className="flex items-start gap-4 mb-6" data-id="element-37">
              <div className="bg-[#d4738c] p-3 rounded-full text-white shrink-0" data-id="element-38">
                <Clock size={24} data-id="element-39" />
              </div>
              <div data-id="element-40">
                <h3 className="text-2xl font-bold text-gray-900 m-0 font-serif" data-id="element-41">
                  La Prueba de los 10 Segundos
                </h3>
                <p className="text-gray-600 mt-2 m-0" data-id="element-42">
                  Sigue estos pasos ahora mismo:
                </p>
              </div>
            </div>

            <div className="space-y-4 text-gray-800" data-id="element-43">
              <p data-id="element-44">
                Fernanda le pidió a Gloria que presionara con el dedo pulgar la
                parte interna de su tobillo, justo arriba del hueso. Que
                mantuviera la presión por 10 segundos. Y que luego soltara.
              </p>
              <p data-id="element-45">Gloria lo hizo.</p>
              <p data-id="element-46">
                Cuando quitó el dedo, una marca hundida quedó en su piel. Como
                si hubiera presionado plastilina. La marca tardó casi un minuto
                en desaparecer.
              </p>
              <p className="font-bold text-[#d4738c]" data-id="element-47">
                "Mamá," dijo Fernanda con voz seria, "esto no es cansancio
                normal."
              </p>
            </div>
          </div>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6" data-id="element-48">
            Ahora hazla tú.
          </h2>

          <p className="mb-6" data-id="element-49">Detente un momento. Esto es importante.</p>

          <p className="mb-6" data-id="element-50">
            Presiona con tu dedo pulgar la parte interna de tu tobillo, justo
            donde termina el hueso. Mantén la presión por 10 segundos completos.
            Ahora suelta.
          </p>

          <div className="bg-rose-50 p-6 rounded-xl my-8 border border-rose-100" data-id="element-51">
            <ul className="list-none space-y-4 m-0 p-0" data-id="element-52">
              <li className="flex items-center gap-3 font-bold text-gray-900 text-lg" data-id="element-53">
                <AlertCircle className="text-[#d4738c]" data-id="element-54" />
                ¿Quedó una marca hundida?
              </li>
              <li className="flex items-center gap-3 font-bold text-gray-900 text-lg" data-id="element-55">
                <AlertCircle className="text-[#d4738c]" data-id="element-56" />
                ¿Tardó más de 5 segundos en desaparecer?
              </li>
            </ul>
          </div>

          <p className="mb-6" data-id="element-57">
            Si tu respuesta es sí, lo que estás a punto de leer podría cambiar
            tu vida. Porque esa marca significa que hay líquido atrapado donde
            no debería estar. Y eso es una señal de que tu circulación está
            comprometida.
          </p>

          <p className="mb-6" data-id="element-58">
            El 65% de las mujeres mexicanas que tienen este problema no lo
            saben. Creen que es "cansancio." Creen que es "la edad." Creen que
            es "normal."
          </p>

          <p className="font-bold text-xl text-gray-900 mb-6" data-id="element-59">No lo es.</p>

          <p className="mb-6" data-id="element-60">
            Y Gloria estuvo a punto de descubrirlo de la peor manera.
          </p>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6" data-id="element-61">
            Lo Que Nadie Le Había Dicho a Gloria
          </h2>

          <p className="mb-6" data-id="element-62">
            Durante tres años, Gloria había ignorado las señales.
          </p>

          <ul className="space-y-4 my-6" data-id="element-63">
            <li className="flex gap-4" data-id="element-64">
              <div className="w-2 h-2 bg-[#d4738c] rounded-full mt-3 shrink-0" data-id="element-65"></div>
              <p className="m-0" data-id="element-66">
                Cuando sus piernas se sentían como piedras al final del día, se
                decía: "Es que estuve parada mucho rato."
              </p>
            </li>
            <li className="flex gap-4" data-id="element-67">
              <div className="w-2 h-2 bg-[#d4738c] rounded-full mt-3 shrink-0" data-id="element-68"></div>
              <p className="m-0" data-id="element-69">
                Cuando sus pies se hinchaban tanto que no podía usar sus
                sandalias favoritas, pensaba: "Ya estoy vieja, qué le voy a
                hacer."
              </p>
            </li>
            <li className="flex gap-4" data-id="element-70">
              <div className="w-2 h-2 bg-[#d4738c] rounded-full mt-3 shrink-0" data-id="element-71"></div>
              <p className="m-0" data-id="element-72">
                Cuando fue al IMSS buscando respuestas, el doctor la vio cinco
                minutos y le dijo: "Es normal a su edad, señora. Tome más agua y
                suba los pies en la noche."
              </p>
            </li>
          </ul>

          <p className="mb-6" data-id="element-73">
            Gloria siguió las instrucciones. Tomó más agua. Subió los pies. Nada
            cambió.
          </p>

          <p className="mb-6" data-id="element-74">
            Lo que Gloria no sabía — lo que el 65% de las mujeres mexicanas con
            piernas hinchadas no saben — es que ese síntoma que ella llamaba
            "cansancio" era su cuerpo enviándole una señal de alarma.
          </p>

          <div className="bg-gray-50 p-6 rounded-xl border-l-4 border-gray-900 my-8" data-id="element-75">
            <p className="text-sm font-bold text-gray-500 uppercase tracking-wide mb-2" data-id="element-76">
              Angiólogo del Hospital ABC
            </p>
            <p className="italic text-gray-800 m-0" data-id="element-77">
              "Cuando presionas el tobillo y queda una marca, eso se llama edema
              con fóvea. Significa que hay líquido acumulado en los tejidos
              porque la sangre no está circulando correctamente. Es como una
              tubería tapada. Y si no se atiende, el problema solo empeora."
            </p>
          </div>

          <p className="mb-6" data-id="element-78">
            Gloria había vivido con esa "tubería tapada" por años. Y estaba a
            punto de pagar las consecuencias.
          </p>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6" data-id="element-79">
            El Día Que Todo Se Derrumbó
          </h2>

          <p className="mb-6" data-id="element-80">
            Tres semanas después de aquella noche en el sillón, la nieta de
            Gloria tenía su festival de fin de año en la primaria. Gloria había
            prometido ir. Había prometido estar ahí, en primera fila,
            aplaudiendo.
          </p>

          <p className="mb-6" data-id="element-81">
            Esa mañana, Gloria se levantó y sintió las piernas más pesadas que
            nunca. Como si alguien le hubiera amarrado ladrillos en los tobillos
            mientras dormía.
          </p>

          <p className="mb-6" data-id="element-82">
            "Voy a estar bien," se dijo. "Solo tengo que llegar a la escuela."
          </p>

          <p className="font-bold mb-6" data-id="element-83">No pudo.</p>

          <p className="mb-6" data-id="element-84">
            A mitad del camino, tuvo que sentarse en una banca. Las piernas
            simplemente no respondían. El corazón le latía fuerte solo de haber
            caminado tres cuadras. Vio cómo otras abuelas pasaban caminando,
            platicando, riendo. Ella no podía ni levantarse.
          </p>

          <p className="mb-6" data-id="element-85">
            Llegó tarde. Se perdió el baile de su nieta. Tuvo que quedarse
            sentada en la última fila mientras todas las demás familias estaban
            de pie, grabando con sus celulares.
          </p>

          <p className="mb-6" data-id="element-86">
            "Ese día algo se rompió dentro de mí," cuenta Gloria. "No era solo
            vergüenza. Era miedo. Pensé: ¿y si un día ya no puedo ni levantarme
            de mi cama? ¿Y si me convierto en una carga para mi familia?"
          </p>

          <p className="mb-6" data-id="element-87">
            Gloria se dio cuenta de algo más doloroso aún: llevaba meses —
            quizás años — dejando de hacer cosas sin darse cuenta.
          </p>

          <div className="grid md:grid-cols-3 gap-4 my-8" data-id="element-88">
            <div className="bg-gray-50 p-4 rounded-lg text-center" data-id="element-89">
              <span className="block text-3xl mb-2" data-id="element-90">🛍️</span>
              <p className="text-sm font-bold text-gray-900" data-id="element-91">
                Ya no iba al tianguis
              </p>
              <p className="text-xs text-gray-600" data-id="element-92">"Caminar tanto me cansa"</p>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg text-center" data-id="element-93">
              <span className="block text-3xl mb-2" data-id="element-94">👗</span>
              <p className="text-sm font-bold text-gray-900" data-id="element-95">
                Ya no usaba vestidos
              </p>
              <p className="text-xs text-gray-600" data-id="element-96">"Mis piernas se ven feas"</p>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg text-center" data-id="element-97">
              <span className="block text-3xl mb-2" data-id="element-98">💃</span>
              <p className="text-sm font-bold text-gray-900" data-id="element-99">Ya no bailaba</p>
              <p className="text-xs text-gray-600" data-id="element-100">"Me canso muy rápido"</p>
            </div>
          </div>

          <p className="mb-6" data-id="element-101">
            Se había convertido en espectadora de su propia vida. Y lo peor: lo
            había aceptado como "normal."
          </p>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6" data-id="element-102">
            Todo Lo Que Gloria Intentó (Y Por Qué Nada Funcionó)
          </h2>

          <p className="mb-6" data-id="element-103">
            Después del incidente del festival, Gloria decidió que tenía que
            hacer algo. Probó todo lo que encontró:
          </p>

          <div className="space-y-6 my-8" data-id="element-104">
            <div className="flex gap-4 items-start" data-id="element-105">
              <div className="bg-red-100 text-red-600 p-2 rounded-full shrink-0 mt-1" data-id="element-106">
                <span className="font-bold text-xl" data-id="element-107">✕</span>
              </div>
              <div data-id="element-108">
                <h4 className="font-bold text-gray-900 m-0" data-id="element-109">
                  Gel de castaño de indias
                </h4>
                <p className="text-sm text-gray-600 m-0" data-id="element-110">
                  "Sientes fresquito como 5 minutos y después todo igual. Es
                  como ponerte perfume para tapar que no te bañaste."
                </p>
              </div>
            </div>
            <div className="flex gap-4 items-start" data-id="element-111">
              <div className="bg-red-100 text-red-600 p-2 rounded-full shrink-0 mt-1" data-id="element-112">
                <span className="font-bold text-xl" data-id="element-113">✕</span>
              </div>
              <div data-id="element-114">
                <h4 className="font-bold text-gray-900 m-0" data-id="element-115">
                  Medias de compresión
                </h4>
                <p className="text-sm text-gray-600 m-0" data-id="element-116">
                  "Imposibles con el calor de Guadalajara. Y me hacían sentir
                  como viejita de 80 años."
                </p>
              </div>
            </div>
            <div className="flex gap-4 items-start" data-id="element-117">
              <div className="bg-red-100 text-red-600 p-2 rounded-full shrink-0 mt-1" data-id="element-118">
                <span className="font-bold text-xl" data-id="element-119">✕</span>
              </div>
              <div data-id="element-120">
                <h4 className="font-bold text-gray-900 m-0" data-id="element-121">
                  Pastillas del IMSS
                </h4>
                <p className="text-sm text-gray-600 m-0" data-id="element-122">
                  "Agotadas siempre. Al tercer mes me rendí."
                </p>
              </div>
            </div>
          </div>

          <p className="mb-6" data-id="element-123">Nada funcionaba.</p>
          <p className="mb-6" data-id="element-124">
            "Ya me había resignado," dice Gloria. "Pensé que así iba a ser mi
            vida. Arrastrando los pies, escondiéndome, viendo a todos los demás
            vivir."
          </p>
          <p className="mb-6" data-id="element-125">
            Hasta que su hija le explicó lo que estaba pasando realmente.
          </p>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6" data-id="element-126">
            El Descubrimiento Que Lo Cambió Todo
          </h2>

          <p className="mb-6" data-id="element-127">
            Un domingo, Fernanda llegó a casa de Gloria con noticias.
          </p>
          <p className="mb-6" data-id="element-128">
            "Mamá, ya sé qué tienes. Y ya sé cómo arreglarlo."
          </p>
          <p className="mb-6" data-id="element-129">
            Fernanda le explicó algo que había aprendido en un curso de
            actualización en el hospital. Algo que tres científicos descubrieron
            en 1998, un descubrimiento tan importante que les dieron el Premio
            Nobel de Medicina por ello.
          </p>

          <div className="bg-blue-50 p-6 rounded-xl border border-blue-100 text-center my-8" data-id="element-130">
            <h3 className="text-2xl font-serif font-bold text-blue-900 m-0 mb-2" data-id="element-131">
              Se llama Óxido Nítrico
            </h3>
            <p className="text-blue-800 m-0" data-id="element-132">
              El "director de tráfico" de tu sangre.
            </p>
          </div>

          <p className="mb-6" data-id="element-133">
            "Piensa en el óxido nítrico como el director de tráfico de tu
            sangre," le explicó Fernanda a su mamá. "Es una molécula que tu
            cuerpo produce naturalmente. Su trabajo es decirle a tus vasos
            sanguíneos: ábrete, relájate, deja pasar la sangre."
          </p>

          <p className="mb-6" data-id="element-134">
            Cuando hay suficiente óxido nítrico, los vasos se abren. La sangre
            fluye. Las piernas se sienten ligeras. La mente está clara. La
            energía es buena.
          </p>

          <p className="mb-6" data-id="element-135">Pero aquí está el problema:</p>
          <p className="mb-6" data-id="element-136">
            Después de los 40 años, el cuerpo empieza a producir cada vez menos
            óxido nítrico. Las células que lo generan se dañan y se vuelven
            menos eficientes.
          </p>
          <p className="mb-6" data-id="element-137">Y en las mujeres, esto es aún peor.</p>

          <p className="mb-6" data-id="element-138">
            "Con la menopausia, la caída es brutal," explicó Fernanda. "El
            estrógeno ayuda a producir óxido nítrico. Cuando el estrógeno baja,
            el óxido nítrico se desploma."
          </p>

          <p className="mb-6" data-id="element-139">
            Pero había algo más. Algo que hizo que Gloria se quedara callada.
          </p>

          <p className="mb-6" data-id="element-140">
            "El estrés crónico destruye el óxido nítrico," dijo Fernanda. "Mamá,
            tú llevas toda la vida cargando con todo. Cuidando a todos.
            Sacrificándote por todos. Ese estrés constante mantiene tus vasos
            sanguíneos apretados, cerrados, las 24 horas del día."
          </p>

          <p className="mb-6" data-id="element-141">
            Gloria entendió. Por primera vez en su vida, entendió.
          </p>
          <p className="mb-6" data-id="element-142">
            No era flojera. No era la edad. No era que "así le tocó."
          </p>
          <p className="mb-6" data-id="element-143">
            Era química. Era su cuerpo pagando el precio de años de sacrificio.
            Era lo que Fernanda llamó "La Enfermedad del Sacrificio Silencioso."
          </p>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6" data-id="element-144">
            La Solución Que Gloria Nunca Esperó
          </h2>

          <p className="mb-6" data-id="element-145">
            Fernanda había pasado semanas investigando. Leyó estudios. Consultó
            con colegas. Buscó opciones.
          </p>
          <p className="mb-6" data-id="element-146">
            La ciencia era clara: había dos ingredientes naturales que podían
            restaurar el óxido nítrico en el cuerpo.
          </p>

          <div className="grid md:grid-cols-2 gap-4 my-4" data-id="element-147">
            <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden" data-id="element-148">
              <div className="h-48 w-full" data-id="element-149">
                <img src="https://cdn.magicpatterns.com/uploads/hiQvn9nqbTxSmqwTg7ewke/Captura_de_pantalla_2026-01-26_a_las_11.00.58.png" alt="Betabel fresco" className="h-full w-full object-cover" data-id="element-150" />
              </div>
              <div className="p-4" data-id="element-151">
                <h4 className="font-bold text-lg mb-2" data-id="element-152">
                  1. Extracto de Betabel
                </h4>
                <p className="text-sm text-gray-600" data-id="element-153">
                  El betabel está lleno de nitratos naturales. Tu cuerpo los
                  convierte en óxido nítrico, creando un "atajo" cuando la vía
                  principal está dañada.
                </p>
              </div>
            </div>
            <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden" data-id="element-154">
              <div className="h-48 w-full" data-id="element-155">
                <img src="https://cdn.magicpatterns.com/uploads/2qQXeZa8cPaf4USEoox3U3/Captura_de_pantalla_2026-01-26_a_las_11.01.42.png" alt="Uvas frescas" className="h-full w-full object-cover" data-id="element-156" />
              </div>
              <div className="p-4" data-id="element-157">
                <h4 className="font-bold text-lg mb-2" data-id="element-158">
                  2. Extracto de Semilla de Uva
                </h4>
                <p className="text-sm text-gray-600" data-id="element-159">
                  Ayuda a REPARAR las células dañadas. Mejora la elasticidad de
                  las venas y reduce la inflamación a largo plazo.
                </p>
              </div>
            </div>
          </div>

          <p className="mb-6" data-id="element-160">
            Juntos, funcionan como un "doble puente": uno entrega alivio rápido,
            el otro construye mejoría a largo plazo.
          </p>
          <p className="mb-6" data-id="element-161">El problema era cómo consumirlos.</p>
          <p className="mb-6" data-id="element-162">
            "Los jugos de betabel son un desastre," dijo Fernanda. "Saben
            horrible, manchan todo, y nunca sabes cuánto estás tomando
            realmente. La dosis es inconsistente."
          </p>
          <p className="mb-6" data-id="element-163">Pero entonces encontró algo diferente.</p>

          <div className="bg-[#d4738c] text-white p-8 rounded-2xl my-10 shadow-xl text-center relative overflow-hidden" data-id="element-164">
            <div className="relative z-10" data-id="element-165">
              <h3 className="text-3xl font-serif font-bold mb-4 text-white" data-id="element-166">
                Angelitas
              </h3>
              <p className="text-lg mb-6 text-rose-100" data-id="element-167">
                Una gomita. Sabor fresa. Con 500mg de extracto de betabel y
                150mg de extracto de semilla de uva en cada porción. Dosis
                exacta.
              </p>
              <div className="inline-block bg-white text-[#d4738c] px-6 py-2 rounded-full font-bold text-sm uppercase tracking-wide" data-id="element-168">
                El ritual de 30 segundos
              </div>
            </div>
            {/* Decorative circles */}
            <div className="absolute top-0 left-0 w-32 h-32 bg-white opacity-10 rounded-full -translate-x-1/2 -translate-y-1/2" data-id="element-169"></div>
            <div className="absolute bottom-0 right-0 w-48 h-48 bg-white opacity-10 rounded-full translate-x-1/3 translate-y-1/3" data-id="element-170"></div>
          </div>

          <p className="mb-6" data-id="element-171">
            "Es como tu ritual de 30 segundos cada mañana," le dijo Fernanda a
            su mamá. "Dos gomitas con tu café. Es todo."
          </p>
          <p className="mb-6" data-id="element-172">
            Gloria miró el frasco con desconfianza. Había probado tantas cosas.
            ¿Por qué esto sería diferente?
          </p>
          <p className="mb-6" data-id="element-173">
            Pero confió en su hija. Confió en la ciencia. Y decidió intentarlo.
          </p>
          <p className="mb-6" data-id="element-174">"¿Qué podía perder?"</p>

          <div className="text-center my-8" data-id="element-175">
            <a href="https://angelitasgummy.com/products/angelitas" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#d4738c] hover:bg-[#c05f77] text-white text-base font-bold py-3 px-6 rounded-full shadow-lg transform transition hover:scale-105 no-underline" data-id="element-176">
              Click Aquí Para Conocer ANGELITAS
            </a>
          </div>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6" data-id="element-177">
            Lo Que Pasó Después
          </h2>

          <div className="space-y-8 my-8 relative border-l-2 border-gray-200 pl-8 ml-4" data-id="element-178">
            <div className="relative" data-id="element-179">
              <div className="absolute -left-[41px] top-0 w-6 h-6 bg-gray-200 rounded-full border-4 border-white" data-id="element-180"></div>
              <h4 className="font-bold text-gray-900 text-lg m-0 mb-2" data-id="element-181">
                Semana 1
              </h4>
              <p className="m-0 text-gray-600" data-id="element-182">
                Gloria no notó nada dramático. Pero al final de cada día, sus
                piernas se sentían... ¿menos pesadas?
              </p>
            </div>
            <div className="relative" data-id="element-183">
              <div className="absolute -left-[41px] top-0 w-6 h-6 bg-[#d4738c] rounded-full border-4 border-white" data-id="element-184"></div>
              <h4 className="font-bold text-gray-900 text-lg m-0 mb-2" data-id="element-185">
                Semana 2
              </h4>
              <p className="m-0 text-gray-600" data-id="element-186">
                "Subí las escaleras de mi casa sin detenerme. Ni me di cuenta
                hasta que llegué arriba."
              </p>
            </div>
            <div className="relative" data-id="element-187">
              <div className="absolute -left-[41px] top-0 w-6 h-6 bg-[#d4738c] rounded-full border-4 border-white" data-id="element-188"></div>
              <h4 className="font-bold text-gray-900 text-lg m-0 mb-2" data-id="element-189">
                Semana 3
              </h4>
              <p className="m-0 text-gray-600" data-id="element-190">
                Su esposo lo notó: "Ya no se te ven tan hinchados los pies." Por
                primera vez en años, podía ver el hueso.
              </p>
            </div>
            <div className="relative" data-id="element-191">
              <div className="absolute -left-[41px] top-0 w-6 h-6 bg-[#d4738c] rounded-full border-4 border-white" data-id="element-192"></div>
              <h4 className="font-bold text-gray-900 text-lg m-0 mb-2" data-id="element-193">
                Semana 4
              </h4>
              <p className="m-0 text-gray-600" data-id="element-194">
                Fue al tianguis. Caminó dos horas. Regresó cansada, pero no
                destruida. "Me sentí viva de nuevo."
              </p>
            </div>
          </div>

          <p className="mb-6" data-id="element-195">
            Hoy, tres meses después, Gloria es otra persona.
          </p>
          <p className="mb-6" data-id="element-196">
            Volvió a usar sandalias. Volvió a acompañar a sus nietos a sus
            eventos. Volvió a bailar en la última fiesta familiar — y aguantó
            tres canciones seguidas.
          </p>

          <blockquote className="border-l-4 border-[#d4738c] pl-6 py-2 my-8" data-id="element-197">
            <p className="text-xl font-serif italic text-gray-800 m-0" data-id="element-198">
              "No exagero cuando digo que Angelitas me devolvió mi vida," dice
              Gloria. "No soy la misma. Y mi familia lo nota."
            </p>
          </blockquote>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-8 text-center" data-id="element-199">
            Gloria No Es La Única
          </h2>

          <div className="grid md:grid-cols-3 gap-6 mb-12" data-id="element-200">
            {[{
            name: 'Adriana',
            age: 48,
            loc: 'Querétaro',
            text: 'Mi comadre me insistió tanto que las probé. Llevo un mes y ya no se me hinchan los pies como antes. Ojalá las hubiera encontrado hace años.'
          }, {
            name: 'Laura',
            age: 58,
            loc: 'CDMX',
            text: 'Mis hijas me decían que ya no salía ni al mandado. Ahora con Angelitas hasta las acompaño al tianguis. Un suplemento de 10.'
          }, {
            name: 'Teresa',
            age: 62,
            loc: 'Morelia',
            text: 'Dormía mal y amanecía más cansada. Ahora descanso mejor y despierto con energía. Las amo.'
          }].map((testimonial, i) => <div key={i} className="bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-201">
                {i === 0 && <div className="mb-4 -mx-6 -mt-6" data-id="element-202">
                    <img src="https://cdn.magicpatterns.com/uploads/uSVpTiYRjEiyqmk8qVY9CG/Captura_de_pantalla_2026-01-26_a_las_10.08.14.png" alt="Antes y después - piernas" className="w-full h-64 object-contain rounded-t-xl bg-white" data-id="element-203" />
                  </div>}
                {i === 1 && <div className="mb-4 -mx-6 -mt-6" data-id="element-204">
                    <img src="https://cdn.magicpatterns.com/uploads/g2WArQTBQK7uGMamx9FEsG/TESTS_-_Arcads_image_asset_(26).png" alt="Laura con Angelitas" className="w-full h-64 object-cover rounded-t-xl" data-id="element-205" />
                  </div>}
                {i === 2 && <div className="mb-4 -mx-6 -mt-6" data-id="element-206">
                    <img src="https://cdn.magicpatterns.com/uploads/e78XzTdYW1iLYDUqFhfeE2/TESTS_-_Arcads_image_asset_(25).png" alt="Teresa con Angelitas" className="w-full h-64 object-cover rounded-t-xl" data-id="element-207" />
                  </div>}
                <div className="flex text-[#d4738c] mb-3" data-id="element-208">
                  {[1, 2, 3, 4, 5].map(s => <Star key={s} size={16} fill="currentColor" data-id="element-209" />)}
                </div>
                <p className="text-sm text-gray-700 mb-4 italic" data-id="element-210">
                  "{testimonial.text}"
                </p>
                <div data-id="element-211">
                  <p className="text-xs font-bold text-gray-900 m-0" data-id="element-212">
                    {testimonial.name}, {testimonial.age}
                  </p>
                  <p className="text-[10px] text-gray-500 m-0" data-id="element-213">
                    {testimonial.loc}
                  </p>
                </div>
              </div>)}
          </div>

          <div className="bg-gray-900 text-white p-8 rounded-2xl mb-12" data-id="element-214">
            <h3 className="text-2xl font-serif font-bold mb-6 text-center text-white" data-id="element-215">
              Los números hablan por sí solos
            </h3>
            <div className="grid md:grid-cols-3 gap-8 text-center" data-id="element-216">
              <div data-id="element-217">
                <div className="text-4xl font-bold text-[#d4738c] mb-2" data-id="element-218">
                  94%
                </div>
                <p className="text-sm text-gray-300" data-id="element-219">
                  Sienten las piernas más ligeras en 2 semanas
                </p>
              </div>
              <div data-id="element-220">
                <div className="text-4xl font-bold text-[#d4738c] mb-2" data-id="element-221">
                  92%
                </div>
                <p className="text-sm text-gray-300" data-id="element-222">
                  Notan mejor energía y menos fatiga
                </p>
              </div>
              <div data-id="element-223">
                <div className="text-4xl font-bold text-[#d4738c] mb-2" data-id="element-224">
                  4.9
                </div>
                <p className="text-sm text-gray-300" data-id="element-225">
                  Estrellas en 4,718 reseñas verificadas
                </p>
              </div>
            </div>
          </div>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6" data-id="element-226">
            ¿Y Si Fueras Tú?
          </h2>

          <p className="mb-6" data-id="element-227">
            Gloria era exactamente igual que tú hace tres meses.
          </p>
          <p className="mb-6" data-id="element-228">
            Piernas pesadas al final del día. Pies hinchados que ya no parecían
            suyos. La sensación de que su cuerpo la estaba traicionando.
          </p>
          <p className="mb-6" data-id="element-229">Ahora imagínate:</p>

          <ul className="space-y-3 my-6" data-id="element-230">
            <li className="flex items-center gap-3" data-id="element-231">
              <Check className="text-green-500 shrink-0" data-id="element-232" />
              <span data-id="element-233">Despertar sin esa pesadez en las piernas.</span>
            </li>
            <li className="flex items-center gap-3" data-id="element-234">
              <Check className="text-green-500 shrink-0" data-id="element-235" />
              <span data-id="element-236">
                Llegar al final del día y que tus pies sigan siendo TUS pies.
              </span>
            </li>
            <li className="flex items-center gap-3" data-id="element-237">
              <Check className="text-green-500 shrink-0" data-id="element-238" />
              <span data-id="element-239">Volver a usar sandalias sin vergüenza.</span>
            </li>
            <li className="flex items-center gap-3" data-id="element-240">
              <Check className="text-green-500 shrink-0" data-id="element-241" />
              <span data-id="element-242">
                Seguir siendo el pilar de tu hogar — sin destruirte en el
                proceso.
              </span>
            </li>
          </ul>

          <p className="mb-6" data-id="element-243">
            Esto no es un sueño. Es lo que pasa cuando le das a tu cuerpo lo que
            dejó de producir.
          </p>
          <p className="mb-6" data-id="element-244">
            Es lo que Angelitas hace cada día por miles de mujeres mexicanas.
          </p>
          <p className="font-bold text-xl mb-6" data-id="element-245">
            La pregunta es: ¿vas a seguir esperando?
          </p>

          {/* OFFER SECTION */}
          <div className="border-2 border-[#d4738c] rounded-3xl p-8 my-12 bg-white shadow-xl relative overflow-hidden" data-id="element-246">
            <div className="absolute top-0 right-0 bg-[#d4738c] text-white px-4 py-1 rounded-bl-xl font-bold text-sm" data-id="element-247">
              OFERTA LIMITADA
            </div>

            <h3 className="text-3xl font-serif font-bold text-center mb-2" data-id="element-248">
              Una Oferta Que No Durará Para Siempre
            </h3>
            <p className="text-center text-gray-600 mb-8" data-id="element-249">
              Gracias a historias como la de Gloria, el inventario está volando.
            </p>

            <div className="flex flex-col md:flex-row items-center justify-center gap-8 mb-8" data-id="element-250">
              <div className="w-48 h-48 bg-gray-100 rounded-xl flex items-center justify-center text-gray-400" data-id="element-251">
                {/* Product Placeholder */}
                <img src="https://cdn.magicpatterns.com/uploads/hzf2cKWGSijm3Hg88d7NDB/Diseno_sin_titulo_(6).png" alt="Frasco Angelitas" className="w-full h-full object-contain rounded-xl" data-id="element-252" />
              </div>
              <div className="text-center md:text-left" data-id="element-253">
                <div className="flex items-center justify-center md:justify-start gap-3 mb-2" data-id="element-254">
                  <span className="text-gray-400 line-through text-xl" data-id="element-255">
                    $710 MXN
                  </span>
                  <span className="bg-green-100 text-green-700 px-2 py-1 rounded text-xs font-bold" data-id="element-256">
                    -30% DESCUENTO
                  </span>
                </div>
                <div className="text-5xl font-bold text-gray-900 mb-2" data-id="element-257">
                  $495 MXN
                </div>
                <div className="flex items-center justify-center md:justify-start gap-2 text-sm text-gray-600 mb-4" data-id="element-258">
                  <Truck size={16} data-id="element-259" />
                  <span data-id="element-260">+ ENVÍO GRATIS a todo México</span>
                </div>
                <p className="text-xs text-gray-500 max-w-xs" data-id="element-261">
                  Un frasco dura 30 días. Menos de $12 pesos al día. Menos que
                  un café.
                </p>
              </div>
            </div>

            <div className="bg-gray-50 p-4 rounded-lg mb-8 flex items-start gap-3" data-id="element-262">
              <ShieldCheck className="text-[#d4738c] shrink-0 mt-1" data-id="element-263" />
              <div data-id="element-264">
                <p className="font-bold text-gray-900 text-sm" data-id="element-265">
                  Garantía de 30 días. Sin preguntas.
                </p>
                <p className="text-xs text-gray-600 m-0" data-id="element-266">
                  Si no sientes tus piernas más ligeras, te devolvemos cada
                  peso. El único riesgo es no intentarlo.
                </p>
              </div>
            </div>

            <div className="text-center" data-id="element-267">
              <a href="https://angelitasgummy.com/products/angelitas" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#d4738c] hover:bg-[#b0556d] text-white text-xl font-bold py-4 px-12 rounded-full shadow-lg transform transition hover:scale-105 mb-4 no-underline" data-id="element-268">
                QUIERO PIERNAS LIGERAS →
              </a>
              <p className="text-xs text-gray-500" data-id="element-269">
                Oferta válida solo mientras dure el inventario. Envío en 3-5
                días hábiles.
              </p>
            </div>
          </div>

          <h2 className="text-3xl font-bold text-gray-900 mt-12 mb-6 text-center" data-id="element-270">
            Es Momento de Decidir
          </h2>

          <div className="text-center max-w-xl mx-auto" data-id="element-271">
            <p className="mb-6" data-id="element-272">
              ¿Recuerdas la prueba que hiciste al principio?
            </p>
            <p className="font-bold text-lg mb-6" data-id="element-273">
              ¿Te quedó marca en el tobillo?
            </p>
            <p className="mb-6" data-id="element-274">
              Si la respuesta es sí, tu cuerpo ya te está hablando. Ya te está
              diciendo que algo no está bien.
            </p>
            <p className="mb-6" data-id="element-275">
              Gloria ignoró esa señal por tres años. Tres años de piernas
              pesadas. Tres años de perderse momentos.
            </p>
            <p className="mb-6" data-id="element-276">Tú no tienes que hacer lo mismo.</p>
            <p className="text-xl font-serif italic text-[#d4738c] font-bold my-6" data-id="element-277">
              Tu familia te necesita de pie. Literalmente.
            </p>

            <a href="https://angelitasgummy.com/products/angelitas" target="_blank" rel="noopener noreferrer" className="inline-block bg-[#d4738c] hover:bg-[#b0556d] text-white text-lg font-bold py-3 px-10 rounded-full shadow-md transition-colors no-underline" data-id="element-278">
              PEDIR ANGELITAS AHORA
            </a>
          </div>
        </article>

        {/* Footer */}
        <footer className="mt-20 pt-10 border-t border-gray-200 text-center text-gray-500 text-sm" data-id="element-279">
          <p className="mb-4" data-id="element-280">
            © 2026 Salud y Bienestar. Todos los derechos reservados.
          </p>
          <div className="flex justify-center gap-6 mb-8" data-id="element-281">
            <a href="#" className="hover:text-gray-900" data-id="element-282">
              Privacidad
            </a>
            <a href="#" className="hover:text-gray-900" data-id="element-283">
              Términos
            </a>
            <a href="#" className="hover:text-gray-900" data-id="element-284">
              Contacto
            </a>
          </div>
          <p className="text-xs text-gray-400 max-w-2xl mx-auto" data-id="element-285">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </footer>
      </main>
    </div>;
}